function redirectLogic(
  e,
  setLoading,
  dispatch,
  getCouponUrlAction,
  coupon,
  selectedStore,
  link,
  setSecond,
  setRedirect,
  setRedirect2,
  history
) {
  e.stopPropagation();

  function withReferLogic() {
    history.push(
      `/couponzr/store/${selectedStore.slug.replace(
        " ",
        ""
      )}/coupon/${selectedStore.slug.replace(" ", "")}/${coupon?._id}`
    );

    window.open(coupon?.finalLink);
    return;
  }

  if (
    selectedStore?.v2_store?.[0]?.affiliate_network
      ?.desktop_redirection_type === "zero-redirect-with-refer"
  ) {
    return withReferLogic();
  }

  if (
    coupon?.redirection_type === "zero-redirect-with-refer" &&
    !(
      selectedStore?.v2_store?.[0]?.affiliate_network
        ?.desktop_redirection_type === "zero-redirect-with-refer"
    )
  ) {
    return withReferLogic();
  }

  setLoading(true);
  dispatch(
    getCouponUrlAction({ finalLink: localStorage.getItem("finalLink") })
  );

  if (link) {
    setSecond(true); //to run useEffect even when link has not changed
  }

  if (
    selectedStore?.v2_store?.[0]?.affiliate_network
      ?.desktop_redirection_type === "zero-redirect-without-refer"
  ) {
    setRedirect(true);
  } else if (
    selectedStore?.v2_store?.[0]?.affiliate_network
      ?.desktop_redirection_type === "zero-redirect-with-refer"
  ) {
    setRedirect2(true);
  } else if (coupon?.redirection_type === "zero-redirect-without-refer") {
    setRedirect(true);
  } else if (coupon?.redirection_type === "zero-redirect-with-refer") {
    setRedirect2(true);
  } else {
    localStorage.setItem("redirection_type", coupon?.redirection_type);
    localStorage.setItem(
      "redirection_type_store",
      selectedStore?.v2_store?.[0]?.affiliate_network?.desktop_redirection_type
    );

    window.open(
      `/couponsredirect/store/${selectedStore.slug.replace(
        " ",
        ""
      )}/coupon/${selectedStore.slug.replace(" ", "")}/${coupon?._id}`,
      "_blank"
    );
  }
}

export default redirectLogic;
